import { createContext } from 'react';
export var tooltipContextDefaultValue = {
    tooltipProps: undefined,
    setTooltipProps: function (_props) { return undefined; },
};
export var TooltipContext = createContext(tooltipContextDefaultValue);
